export const trustMd = `# andrum Trust Center

**Senast uppdaterad:** 2026-07-31  
**Publik URL:** https://andrum.app/trust

## Operatör

andrum drivs av **Adam Hjort Consulting AB**, org.nr **559396-6749**, Stockholm.  
Kontakt: [support@andrum.app](mailto:support@andrum.app) · [privacy@andrum.app](mailto:privacy@andrum.app)

## Sammanfattning

andrum är en **icke-klinisk** välmåendetjänst. Data lagras primärt i **EU**. andrum Practice behandlar praktikdata som **personuppgiftsbiträde** under DPA.

## Hosting & region

| System | Leverantör | Region |
|--------|------------|--------|
| App / marketing | Cloudflare Pages | Edge + origin EU |
| API | Fly.io | \`arn\` (Stockholm) |
| Databas & auth | Supabase | EU |
| E-post | Amazon SES | eu-north-1 (mål) |
| Betalning | Stripe | enligt Stripe EU |
| AI | xAI | begränsad prompt; ingen träningsopt-in default |

## Säkerhet (högnivå)

- TLS överallt  
- Multi-tenant isolation + RLS  
- Service role endast på server  
- Auditlogg när terapeut öppnar klientdetalj  
- Rate limits på coach, invites, AI brief  
- Secrets utanför git  

## Practice & samtycke

- Klient måste **acceptera** delning innan terapeut ser data  
- Default share_scope: skalor + completion, **inte** coach-fritext
- Disconnect när som helst (klient eller terapeut)  
- DPA: [\`practice-dpa-sv.md\`](./practice-dpa-sv.md) / [EN](./practice-dpa-en.md)

## Underbiträden

Se DPA bilaga D. Väsentliga byten kommuniceras via denna sida och/eller e-post.

## Incident

Mål: underrätta berörd praktik inom **48 h** efter att vi blivit medvetna om personuppgiftsincident som påverkar dem.

## Kontakt

- Integritet / DPA: privacy@andrum.app (vidarebefordras till ops)  
- Support: support@andrum.app · https://andrum.app/contact  

## Dokument

| Dokument | Länk |
|----------|------|
| Integritet (B2C) | /privacy |
| Villkor | /terms |
| Safety | /safety |
| Practice DPA (SV) | /dpa |
| Practice DPA (EN) | /dpa?lang=en |
| Practice produkt | /practice |
`;
